module.exports = __webpack_public_path__ + "img/32-pathways-towards-a-social-ecological-transformation-in-asian-cities.58b86c75.png";